import { PaymentLedger } from "@/shared/utils/interfaces";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import usePaymentHook from "@/shared/hooks/usePaymentHook";
import { cn } from "@/shared/utils/cn";
import { useSplitPaymentStates } from "@/shared/atoms/useSplitPaymentAtom";
import { useReadSplitPaymentOrdersState } from "@/shared/atoms/useSplitPaymentV2Atom";

type Props = {
  ledger: PaymentLedger;
  defaultLedger: PaymentLedger;
  isFetching: boolean;
  onClickPayment: () => void;
  onClickPrint: () => void;
  onClickDelete: () => void;
};

const SplitPaymentLedgerAction = ({
  ledger,
  defaultLedger,
  isFetching,
  onClickPayment,
  onClickPrint,
  onClickDelete,
}: Props) => {
  const { t } = useTranslation();
  const { isOnlinePayment } = usePaymentHook();
  const { splitType } = useReadSplitPaymentOrdersState();

  const isDefaultPaidOnline =
    isOnlinePayment(defaultLedger?.payment_method_id) && defaultLedger?.is_paid;

  const isPaymentBtnDisabled =
    isDefaultPaidOnline ||
    (isOnlinePayment(ledger.payment_method_id) && !ledger.transaction_email) ||
    Boolean(ledger.payment_method_id) === false;

  return (
    <div className="flex justify-between gap-4  -mt-4">
      <Button variant="danger" onClick={onClickDelete} className="w-full">
        {t("delete")}
      </Button>
      {splitType === "cart" && (
        <Button
          onClick={onClickPrint}
          className={cn("w-full")}
          variant="secondary"
        >
          {t("print")}
        </Button>
      )}
      <Button
        onClick={onClickPayment}
        isDisabled={isPaymentBtnDisabled}
        isPending={isFetching}
        className="w-full"
        variant="default"
      >
        {isOnlinePayment(ledger.payment_method_id)
          ? t("posOrders.startPayment")
          : t("posOrders.registerPayment")}
      </Button>
    </div>
  );
};

export default SplitPaymentLedgerAction;
